import React, { useEffect, useState } from 'react'
import { Box, CircularProgress } from '@material-ui/core'

import { Onboarding } from './Onboarding'
import { Payments } from './Payments'
import { useAppDispatch, useUser } from '../../hooks'
import { useRent, StripeAccountStatus } from '../../hooks/useRent'
import { StripeConnectAccount } from '../../models/Rent/types'
import { setWorkSpaceUser } from '../../store'

export const RentHome = () => {
    const dispatch = useAppDispatch()
    const { workspaceUser } = useUser()
    const { fetchStripeConnectAccount } = useRent()
    const [stripeConnectAccount, setStripeConnectAccount] = useState<
        StripeConnectAccount | null | undefined
    >(undefined)

    useEffect(() => {
        if (!workspaceUser) return

        setStripeConnectAccount(undefined)
        let cancelled = false

        const syncStripeAccount = async () => {
            try {
                const account = await fetchStripeConnectAccount()
                if (cancelled) return

                setStripeConnectAccount(account)
                dispatch(
                    setWorkSpaceUser({
                        ...workspaceUser,
                        active_workspace: {
                            ...workspaceUser.active_workspace,
                            stripe_connect_account: account,
                        },
                    }),
                )
            } catch {
                if (cancelled) return
                setStripeConnectAccount(
                    workspaceUser.active_workspace.stripe_connect_account ??
                        null,
                )
            }
        }

        syncStripeAccount()

        return () => {
            cancelled = true
        }
    }, [workspaceUser?.id, dispatch, fetchStripeConnectAccount])

    if (stripeConnectAccount === undefined) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="100vh"
            >
                <CircularProgress />
            </Box>
        )
    }

    if (!stripeConnectAccount || stripeConnectAccount.status !== 'enabled') {
        return (
            <Onboarding
                stripeAccountStatus={
                    stripeConnectAccount?.status as
                        | StripeAccountStatus
                        | undefined
                }
            />
        )
    }

    return <Payments />
}
